import { Col } from "antd";
import { Link } from 'react-router-dom';
import { FC } from "react";
import  inicio  from './inicio.svg';

interface IProps {
  routes: Array<routesModel>;
}

interface routesModel {
  nombre: string;
  to?: string;
}

export const BreadCrumbAdmin: FC<IProps> = ({ routes }) => {
  return (
    <Col span={24}>
      <div className="d-flex justify-content-between align-items-center bar"
        style={{
          backgroundColor: '#101c31',
          padding: '4px 24px',
          color: 'white',
          boxShadow: 'inset 0px 5px 3px #00000015',
        }}
      >
        <ol className="breadcrumb m-0"

        >
          <li className="breadcrumb-item " style={{ fontSize: '10px', fontFamily: 'Montserrat-SemiBold' }}>
            <Link to="/administrador" className="text-white">
              {/* <HomeFilled /> */}
              <img src={inicio} alt="" />
            </Link>
          </li>
          {routes &&
            routes.length > 0 &&
            routes.map((breadcrumb) => {
              return (
                <li key={breadcrumb.to || breadcrumb.nombre} className="breadcrumb-item font-color-FFFFFF " style={{ fontSize: '10px',   fontFamily: 'Montserrat-Regular' }} aria-current="page">
                  {breadcrumb.to && (
                    <Link to={breadcrumb.to} className="bread-crumb text-white " style={{textDecoration: 'underline', fontFamily: 'Montserrat-Regular'}}>
                      {breadcrumb.nombre}
                    </Link>
                  )}
                  {!breadcrumb.to && breadcrumb.nombre}
                </li>
              );
            })}
        </ol>

      </div>
    </Col>

  );
};
